<!-- History side panel: collapsible container for chat history -->
<aside class="history-side-panel" [class.collapsed]="isCollapsed">

    <!-- Collapsed state: floating overlay button -->
    @if (isCollapsed) {
    <div class="collapsed-strip">
        <button class="expand-collapse-btn" (click)="toggleCollapse()" aria-label="Expand panel">
            <img class="collapse-icon" src="assets/icons/side-bar-icon.png" alt="" />
        </button>
    </div>
    }

    <!-- Expanded state: full panel content -->
    @if (!isCollapsed) {
    <div class="panel-content">
        <!-- Header: brand + collapse toggle -->
        <div class="panel-header">
            <div class="brand">
                <img class="brand-icon" src="assets/icons/history-icon-and-label.svg" alt="History" />
            </div>
            <button class="collapse-btn" (click)="toggleCollapse()" aria-label="Collapse panel">
                <img class="collapse-icon" src="assets/icons/side-bar-icon.png" alt="" />
            </button>
        </div>
        <!-- Search: filter chats by query -->
        <div class="search-container">
            <div class="search-wrapper">
                <img class="search-icon" src="assets/icons/search.png" alt="" />
                <input type="text" class="search-input" placeholder="Search chats" [ngModel]="searchQuery"
                       (ngModelChange)="onSearchChange($event)" />
                @if (searchQuery) {
                <button type="button" class="clear-search-btn" (click)="clearSearch()" aria-label="Clear search">
                    ×
                </button>
                }
            </div>
        </div>
        @if (isReadyToLoad()) {
        <!-- Connection lost message -->
        @if (!isNetworkOnline) {
        <div class="connection-lost-message">
            <span>Connection lost. Some history may not load. Please try again.</span>
        </div>
        }
        <!-- Load Sessions - Error message with retry button -->
        @if (hasLoadError && !isLoading) {
        <div class="error-state">
            <div class="error-message">
                <span>History couldn’t load. Please try again.</span>
            </div>
            <sabis-retry-button [title]="'Retry'"
                                [disabled]="!isNetworkOnline"
                                (retryClick)="reloadHistory()">
            </sabis-retry-button>
        </div>
        }
        <!-- History list: grouped chat items (e.g. Today, Yesterday) -->
        <div class="history-list">
            @for (group of historyGroups; track group) {
            <div class="history-group">
                <!-- Group header: label + expand/collapse -->
                <button class="group-header" (click)="toggleGroup(group)">
                    <span class="group-label">{{ group.date | dateFormat }}</span>
                    <svg class="expand-icon" [class.collapsed]="!group.isExpanded" viewBox="0 0 24 24" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 8L6 14L7.41 15.41L12 10.83L16.59 15.41L18 14L12 8Z" fill="currentColor" />
                    </svg>
                </button>
                <!-- Group items: individual chat entries with optional edit -->
                @if (group.isExpanded) {
                <div class="group-items">
                    @for (item of group.items; track item) {
                    <div class="history-item"
                         [class.selected]="item.llmSessionId == selectedChatId"
                         [class.editing]="item.llmSessionId == editingItemId"
                         [class.disabled]="!isNetworkOnline"
                         (click)="isNetworkOnline && editingItemId !== item.llmSessionId && selectChatClick(item)">
                        <!-- Edit mode: show input -->
                        @if (item.llmSessionId == editingItemId) {
                        <input #editInput
                               type="text"
                               class="edit-title-input"
                               [(ngModel)]="editingTitle"
                               [disabled]="isSavingTitle || !isNetworkOnline"
                               (keydown)="onEditKeydown($event, item)"
                               (blur)="onEditBlur(item)"
                               (click)="$event.stopPropagation()"
                               maxlength="100" />
                        }
                        <!-- View mode: show title and edit button -->
                        @if (item.llmSessionId != editingItemId) {
                        <span class="item-title" [innerHTML]="item.title | highlight:searchQuery"></span>
                        <!-- Temporary commented the edit button (Not requested in the meantime)-->
                        <!-- <button *ngIf="item.llmSessionId == selectedChatId"
                        class="edit-btn"
                        (click)="onEditChat($event, item)"
                        [disabled]="!isNetworkOnline"
                        aria-label="Edit chat">
                        <img class="edit-icon"
                          src="assets/icons/edit-icon.png"
                          alt="Edit chat"
                          width="18"
                          height="18" />
                        </button> -->
                        }
                    </div>
                    }
                </div>
                }
            </div>
            }
            <!-- Load more: fetch next sessions on demand -->
            @if (hasMore) {
            <div class="load-more-container">
                <button type="button" class="load-more-btn" [disabled]="isLoadMoreLoading || !isNetworkOnline" (click)="loadMore()">
                    @if (!isLoadMoreLoading) {
                    <span>Load more</span>
                    }
                    @if (isLoadMoreLoading) {
                    <span>Loading…</span>
                    }
                </button>
            </div>
            }
            <!-- Empty state: shown when search has no matches -->
            @if (historyGroups.length === 0 && searchQuery && !isLoading) {
            <div class="empty-state">
                <span>No chats found</span>
            </div>
            }
        </div>
        }
    </div>
    }
</aside>
